<template>
	<v-responsive>
		<template v-if="loading">
			<rmp-details-group>
				<rmp-details-subheader-loader></rmp-details-subheader-loader>
				<rmp-details-item-loader></rmp-details-item-loader>
				<rmp-details-item-loader></rmp-details-item-loader>
				<rmp-details-item-loader></rmp-details-item-loader>
			</rmp-details-group>
		</template>
		<template v-else>
			<rmp-details-group>
				<rmp-details-section-title v-if="title">{{ title }}</rmp-details-section-title>
				<rmp-details-subheader>{{ tc("details.titles.general") }}</rmp-details-subheader>
				<rmp-details-item bold :title="tc('details.titles.fullPersonName')" :value="details.fullName"></rmp-details-item>
				<rmp-details-item bold :title="tc('details.titles.inn')" :value="details.inn"></rmp-details-item>
				<rmp-details-item bold :title="tc('details.titles.ogrn')" :value="details.ogrn"></rmp-details-item>
			</rmp-details-group>
		</template>
	</v-responsive>
</template>

<script setup lang="ts">
import RmpDetailsGroup from "@rmp/core/components/details/RmpDetailsGroup.vue";
import RmpDetailsItem from "@rmp/core/components/details/RmpDetailsItem.vue";
import RmpDetailsSectionTitle from "@rmp/core/components/details/RmpDetailsSectionTitle.vue";
import RmpDetailsSubheader from "@rmp/core/components/details/RmpDetailsSubheader.vue";
import RmpDetailsItemLoader from "@rmp/core/components/loaders/details/RmpDetailsItemLoader.vue";
import RmpDetailsSubheaderLoader from "@rmp/core/components/loaders/details/RmpDetailsSubheaderLoader.vue";

import { ApiEgrulEgripEntrepreneur } from "@rmp/api-gateway";
import { useI18n } from "vue-i18n-composable";

const { tc } = useI18n();

interface Props {
	details: ApiEgrulEgripEntrepreneur;
	title?: string;
	loading?: boolean;
}

const props = defineProps<Props>();
</script>
